import { render, staticRenderFns } from "./SpecialLeaveApplications.vue?vue&type=template&id=73511a40&scoped=true"
import script from "./SpecialLeaveApplications.vue?vue&type=script&lang=js"
export * from "./SpecialLeaveApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73511a40",
  null
  
)

export default component.exports